import type { DiffusionFilters } from '~/utils/diffusion'

function emptyDiffusionFilters(): DiffusionFilters {
  return { reference: '', localite: '', transaction: [], partenaire: [], statut: [] }
}

export function useDiffusionFilters() {
  const applied = useState<DiffusionFilters>('diffusion-filters', emptyDiffusionFilters)

  function apply(filters: DiffusionFilters) {
    applied.value = {
      reference: filters.reference,
      localite: filters.localite,
      transaction: [...filters.transaction],
      partenaire: [...filters.partenaire],
      statut: [...filters.statut],
    }
  }

  function reset() {
    applied.value = emptyDiffusionFilters()
  }

  return { applied, apply, reset }
}
